import MainClass, { MAIN_CLASS_PARAMS } from "../utils/mainClass.ts";

class AnnualReports extends MainClass {
    
    constructor( options: MAIN_CLASS_PARAMS ) {
        super( options );
        this.selector && this.init();
    }
    init () {
       const pastAnnualReportBtn = this.selector.querySelector( '.js-past-annual-reports-btn' ) as HTMLElement;
       if (pastAnnualReportBtn) {
        pastAnnualReportBtn.addEventListener('click', () => {
            const listReportWrapper = this.selector.querySelector( '.js-past-annual-reports-wrapper' ) as HTMLElement;
            const listReport = this.selector.querySelector( '.js-past-annual-reports-list' ) as HTMLElement;
            const iconDropdown = this.selector.querySelector( '.icon-dropdown' ) as HTMLElement;
            iconDropdown.classList.toggle( 'active' );
            if (listReportWrapper && listReport) {
                if (listReportWrapper.getAttribute("style")) {
                    listReportWrapper.removeAttribute("style");
                } else {
                    listReportWrapper.style.height = `${listReport.clientHeight}px`;
                }
            }
        })
       }
    }
}

export default AnnualReports;